function cov_1iky5978qd() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeCost.tsx";
  var hash = "0c98686a9ef966e2a11330127db0199f2185a8ce";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeCost.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 49
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0c98686a9ef966e2a11330127db0199f2185a8ce"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1iky5978qd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1iky5978qd();
var Icon = (cov_1iky5978qd().s[0]++, {
  name: 'home-cost',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 10.3016L12 5.05164L4.5 10.3016V19.5H19.5V10.3016ZM22 9.52066V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V9.52066C2 9.19434 2.15921 8.88855 2.42654 8.70143L11.4265 2.40143C11.7709 2.1604 12.2291 2.1604 12.5735 2.40143L21.5735 8.70143C21.8408 8.88855 22 9.19434 22 9.52066Z\" fill=\"currentColor\"/>\n  <path d=\"M12.7839 16.8182V17.8327C12.7839 17.8781 12.7652 17.9216 12.732 17.9537C12.6987 17.9858 12.6536 18.0039 12.6066 18.0039H11.3652C11.3182 18.0039 11.2731 17.9858 11.2398 17.9537C11.2066 17.9216 11.1879 17.8781 11.1879 17.8327V16.7959C10.3257 16.67 9.5289 16.2778 8.91704 15.6779C8.89646 15.6574 8.88403 15.6305 8.88192 15.602C8.87982 15.5735 8.88817 15.5452 8.90551 15.5221L9.65832 14.5393C9.66926 14.5248 9.68339 14.5128 9.69971 14.5041C9.71602 14.4955 9.73412 14.4905 9.75269 14.4894C9.77126 14.4884 9.78983 14.4913 9.80709 14.498C9.82435 14.5047 9.83986 14.515 9.8525 14.5282C10.1429 14.8324 10.4951 15.0755 10.8872 15.2424C11.2793 15.4093 11.7028 15.4963 12.1313 15.4981C13.1404 15.4981 13.4995 15.0452 13.4995 14.6215C13.4995 14.0624 12.7431 13.8767 11.8662 13.6626C10.6514 13.3664 9.1396 12.9966 9.1396 11.388C9.1396 10.2862 9.95536 9.46351 11.1985 9.21782V8.17339C11.1985 8.12798 11.2172 8.08443 11.2505 8.05232C11.2837 8.02021 11.3288 8.00217 11.3759 8.00217H12.6172C12.6643 8.00217 12.7094 8.02021 12.7426 8.05232C12.7759 8.08443 12.7946 8.12798 12.7946 8.17339V9.2007C13.584 9.31156 14.3173 9.65926 14.8907 10.1946C14.9122 10.2154 14.9252 10.2429 14.9274 10.2722C14.9295 10.3014 14.9206 10.3304 14.9023 10.3539L14.161 11.2956C14.1501 11.3094 14.1362 11.3208 14.1204 11.329C14.1045 11.3372 14.0871 11.3421 14.0691 11.3433C14.0512 11.3445 14.0331 11.3421 14.0163 11.336C13.9994 11.33 13.984 11.3206 13.9712 11.3084C13.6948 11.0482 13.3677 10.8435 13.0088 10.7061C12.6499 10.5687 12.2664 10.5013 11.8804 10.508C11.203 10.508 10.7472 10.8213 10.7472 11.287C10.7472 11.7527 11.4565 11.9316 12.2838 12.1345C13.5421 12.4453 15.108 12.8305 15.108 14.499C15.0973 15.5109 14.474 16.5845 12.7839 16.8182Z\" fill=\"currentColor\"/>"
});
export default Icon;